import {now} from 'lib/date-time'
import {getLocalStorageItem} from 'lib/localStorage'
import {TEAM_MEMBER_TOKEN_KEY} from 'obvio/auth'

type AuthToken = string

const LAST_LOGGED_OUT_TIME = '__last_logged_out_time__'

// Temp access tokens are used to authenticate as another team member. Typically used for support
// staff that need to login as the user they are helping in another browser tab.
export const TEMP_TEAM_MEMBER_TOKEN_KEY = '__obvio_temp_access_token__'

export function getToken(key: string): AuthToken | null {
  if (key === TEAM_MEMBER_TOKEN_KEY && hasTempAccessToken()) {
    return sessionStorage.getItem(TEMP_TEAM_MEMBER_TOKEN_KEY)
  }

  return getLocalStorageItem(key)
}

export function saveToken(key: string, token: string) {
  return new Promise<void>((resolve) => {
    window.localStorage.setItem(key, token)
    resolve()
  })
}

export function deleteToken(key: string) {
  return window.localStorage.removeItem(key)
}

// Storing a timestamp of when the user clicks the "logout" link. This is used
// for "deep link" remembering of a requested location, we don't care to remember
// a request immediately after a user clicks "logout".
export function setLastLoggedOut() {
  return window.localStorage.setItem(LAST_LOGGED_OUT_TIME, now())
}

export function getLastLoggedOut() {
  return getLocalStorageItem(LAST_LOGGED_OUT_TIME)
}

export function clearLastLoggedOut() {
  return window.localStorage.removeItem(LAST_LOGGED_OUT_TIME)
}

export function saveTempAccessToken(token: string) {
  sessionStorage.setItem(TEMP_TEAM_MEMBER_TOKEN_KEY, token)
}

export function hasTempAccessToken() {
  return Boolean(sessionStorage.getItem(TEMP_TEAM_MEMBER_TOKEN_KEY))
}

export function getTempAccessToken() {
  return sessionStorage.getItem(TEMP_TEAM_MEMBER_TOKEN_KEY)
}
